/**
 *
 * App.js
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 *
 */

import React, { useEffect } from 'react';
import { Switch, Route } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';
import reducer from './reducer';
import saga from './saga';

import AccountActivatePage from 'containers/Account/Activate/Loadable';
import AccountActivationSsoPage from 'containers/Account/ActivateSso/Loadable';
import LoginPage from 'containers/LoginPage/Loadable';
import SsoPage from 'containers/Account/Sso/Loadable';
import ForgotPassword from 'containers/Account/ForgotPassword/Loadable';
import ResetPassword from 'containers/Account/ResetPassword/Loadable';

import NotFoundPage from 'containers/NotFoundPage/Loadable';

import routes from 'components/NavBar/routes.js';
import PrivateRoute from './private';
import { selectTheme, featureAllowed } from './selectors';

import { hasAuthToken } from '../../utils/auth';
import './style.scss';
import configs from 'configs';
const { style } = configs
import ('../../styles/customizations/' + style + '/style.scss');


function isLoggedIn() {
  return hasAuthToken();
}

class App extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const pageTitle = document.querySelector('title');

    pageTitle.innerText = configs.appTitle;
  }

  componentDidUpdate() {
    if (isLoggedIn()) {
      if (this.props.featureAllowed('rebrand')) {
        document.body.classList.add(`theme-${this.props.theme}`);
      }
    }
  }

  render() {
    return (
      <Switch>
        <Route exact path="/sso" component={SsoPage} />
        <Route exact path="/login" component={LoginPage} />
        <Route
          exact
          path="/account/activate/:token"
          component={AccountActivatePage}
        />
        <Route
          exact
          path="/sso/activate/"
          component={AccountActivationSsoPage}
        />
        <Route
          exact
          path="/account/password/forgot"
          component={ForgotPassword}
        />
        <Route
          exact
          path="/account/password/:token"
          component={ResetPassword}
        />
        {routes.map((route, key) => {
          if (route.component &&
            (!route.hasOwnProperty('feature') || this.props.featureAllowed(route.feature))
          ) {
            let RouteComponent = route.component;

            return <PrivateRoute
              key={key}
              authentication={isLoggedIn()}
              exact
              hasFaqSalesBot={false}
              path={route.path}
              component={RouteComponent}
            />;
          }
        })}
        <PrivateRoute authentication={isLoggedIn()} component={NotFoundPage} />
      </Switch>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  theme: selectTheme(),
  featureAllowed: (state, featureSlug) => featureAllowed(state, featureSlug),
});

const withReducer = injectReducer({ key: 'user', reducer });
const withSaga = injectSaga({ key: 'user', saga });

const withConnect = connect(
  mapStateToProps,
);

export default compose(
  withReducer,
  withSaga,
  withConnect,
)(App);
